// dialog-transferir-pessoa.component.ts
import { Component, Input, OnInit, inject } from '@angular/core';
import {
  NbDialogRef,
  NbCardModule,
  NbButtonModule,
  NbSelectModule,
} from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Turma } from '../../../core/api/turma';
import { TurmaService } from '../../../core/api/turma.service';


@Component({
  selector: 'app-dialog-transferir-pessoa',
  standalone: true,
  imports: [CommonModule, NbCardModule, NbButtonModule, NbSelectModule, FormsModule],
  template: `
    <nb-card class="dialog-card">
      <nb-card-header>Transferir pessoa</nb-card-header>
      <nb-card-body>
        <p class="transferir-hint">Selecione a turma para onde deseja transferir <b>{{ pessoaNome }}</b>:</p>
        <nb-select
          fullWidth
          placeholder="Selecione a nova turma"
          [(selected)]="turmaDestinoId">
          <nb-option *ngFor="let turma of turmas" [value]="turma.id">
            {{ turma.nome }}
          </nb-option>
        </nb-select>
      </nb-card-body>
      <nb-card-footer class="footer-actions">
        <button nbButton status="basic" size="medium" type="button" (click)="cancelar()">Cancelar</button>
        <button nbButton status="primary" size="medium" type="button" (click)="confirmar()" [disabled]="!turmaDestinoId">
          Transferir
        </button>
      </nb-card-footer>
    </nb-card>
  `,
  styles: [
    `
      .transferir-hint {
        margin: 0 0 1rem;
        line-height: 1.45;
        color: var(--text-basic-color, #222b45);
      }
    `,
  ],
})
export class DialogTransferirPessoaComponent implements OnInit {
  @Input() pessoaNome!: string;
  @Input() turmaAtualId!: string;
  turmas: Turma[] = [];
  turmaDestinoId: string | null = null;

  private turmaService = inject(TurmaService);
  private ref = inject(NbDialogRef<DialogTransferirPessoaComponent>);

  ngOnInit(): void {
    this.turmaService.listar(0, 100, '').subscribe((res) => {
      // Remove a turma atual da lista
      this.turmas = (res.content ?? []).filter((t) => t.id !== this.turmaAtualId);
    });
  }

  confirmar() {
    if (this.turmaDestinoId) {
      this.ref.close(this.turmaDestinoId); // Retorna o ID da nova turma
    }
  }

  cancelar() {
    this.ref.close(null);
  }
}
